import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jtypevar(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
  <title>Java types of variable tutorial For Beginners</title>
<meta name="description" content="Java types of variable tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java type of variable,java check type of variable,java class variable example
,java class member variable,java types of variable,types of variable in java,types of variables in java,java types of variables,javascript variable types
,how many types of variables in java,three types of variable in java,java how to know type of variable,get type of variable in java,java type variable in string
,java type of variable object,java type of variable int,java class variable default value,how many types of variable in java" />
<link rel="canonical" href="https://www.codeexampler.com/java-types-of-variables" />
</Helmet>


<div className='lg:pl-56'>


    <h1 className="m-4 mh1">How many Types of Variable in Java
</h1>
<div className="first">
        <a href="/java-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 ">Java Variables are Three Types:</h2>
    <h3 className="mt-4 mh2">1, Local Variable<br/>
2, Static Variable<br/>
3, Instance Variable<br/>
</h3>
    <h2 className="mt-4 mh2">1, Local Variable:</h2>
    <p className="para mt-4">1, These types of Variable are defined inside a method, blocks, or Constructors
<br/>2, Local Variable scope only inside the method, blocks, or constructors
<br/>3, It Can’t use from outside that function.
<br/>4, The initial value will be garbage
<br/>5, Doesn’t have any default value<br/>
</p>

    
<h2 className="headings">Q-Write a Program local Variable print name in Java Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> Local_example</span>
          <span className="qwerty-5"> {`// class is a keyword `}</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;String </span>
    <span className="qwerty-4">Name;</span>
    <span className="qwerty-5"> {`// This is a Local Variable `}</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;Name</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"Code Exampler";</span>
    {"\n"}
  

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">Name</span>
      <span className="qwerty-1">);</span>
      {"\n"}


<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>






 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Code Exampler </span>          
          {"\n"}
       
            </code>{"   "}
            </pre>
      </div>
    </div>

    <h2 className="mt-4 mh2">2, Static Variables:</h2>
    <p className=" mt-4 para">These<span className="re"> Static variables in Java </span> are declared inside a class using the static keyword this is also known as an instance variable<br/>
          1, Static keyword creates within a class but outside the constructor, method, or blocks.<br/>
          2, Static variables allocate memory when we run the program<br/>
          3, Static variables stored inside static memory<br/>
          4, We also use access  specifiers like-public, private, protected<br/>
          </p>

<h2 className="headings">Q-Write a Program Static variable in Java and print a and b by using new object example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> code</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">20;</span>

          {"\n"}
          <span className="qwerty">&nbsp;&nbsp;&nbsp;static </span>
          <span className="qwerty-2">int </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">40;</span>
          {"\n"}
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;code </span>
    <span className="qwerty-4">sv1</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">code</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"} {"\n"}
      <span className="qwerty-5"> &nbsp;&nbsp;&nbsp;&nbsp;{`// But when we create a new object like this `}</span>
      {"\n"} {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;code </span>
    <span className="qwerty-4">sv2</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">code</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv2</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      <span className="qwerty-5"> {`// Because of instance variable create new memory allocate whenever we created another new object. `}</span>
      {"\n"}


  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv2</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      <span className="qwerty-5"> {`// This value is the same because the static Variable can’t initialize when creating another object. `}</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>






 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span>  
          <span className="qwerty-5">&nbsp;40 </span>         
          {"\n"}
          <span className="qwerty-6">&nbsp;20 </span>  
          {"\n"}
          <span className="qwerty-7">&nbsp;40 </span>         
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a Program when we create a new object in Java with an instance variable example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> code</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">20;</span>

          {"\n"}
          <span className="qwerty">&nbsp;&nbsp;&nbsp;static </span>
          <span className="qwerty-2">int </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">40;</span>
          {"\n"}
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;code </span>
    <span className="qwerty-4">sv1</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">code</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"} {"\n"}
      <span className="qwerty-5"> &nbsp;&nbsp;&nbsp;&nbsp;{`// if you change a value so `}</span>
      {"\n"} {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8"> = </span>
        <span className="qwerty-1">100;</span>

        {"\n"}
        <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
        <span className="qwerty-8"> = </span>
        <span className="qwerty-1">100;</span>
        {"\n"}

        <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv1</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}



      <span className="qwerty-5"> &nbsp;&nbsp;&nbsp;&nbsp;{`// But when we create a new object like this`}</span>


      {"\n"} {"\n"}






      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;code </span>
    <span className="qwerty-4">sv2</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">code</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv2</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      <span className="qwerty-5"> {`// because of instance variable create a new memory allocate whenever we create another object. `}</span>
      {"\n"}


  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">sv2</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      <span className="qwerty-5"> {`// his value is the same because the static Variable can’t initialize when creating another object.`}</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>






 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span> 
          {"\n"} 
          <span className="qwerty-3">&nbsp;40 </span> 
          {"\n"} 
          <span className="qwerty-10">&nbsp;100 </span>  
          {"\n"}
          <span className="qwerty-10">&nbsp;100 </span>         
          {"\n"}
          <span className="qwerty-7">&nbsp;20 </span>         
          {"\n"}
          <span className="qwerty-7">&nbsp;100 </span>         
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">3, Instance Variable:</h2>

<p className="mt-4 para">These<span className="bold"> Instance Variables in Java</span> are declared inside a class. That is known as an instance variable.<br/>
a, These Instance variables are used inside the class but used outside in constructor, method, or blocks.<br/>
b, Instance variable allocated when the object is created <br/></p>

<h3 className="mt-4 mh3">Following Steps of a static Variable in Java:</h3>

<p className="para mt-4" >1, The Instance variable can be called directly in a standard or simple method.<br/>
2, But when we use the static method, so we call an instance variable by using or creating object forex-</p>

<h2 className="headings">Instance variable call by using a method in Java</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-4">&nbsp;Insance_var </span>
    <span className="qwerty-4">iv</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">Insance_var</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  
        <span className="qwerty-4">&nbsp;Abc</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">iv</span>
        <span className="qwerty-1">();</span>

 
        {"\n"}{"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">Q-Instance variable Full example in Java? </h2>


<h2 className="headings">Instance variable example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> code</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">20;</span>
    <span className="qwerty-5">{`// instance variable`}</span>

          {"\n"}
          <span className="qwerty">&nbsp;&nbsp;&nbsp;static </span>
          <span className="qwerty-2">int </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">40;</span>
    <span className="qwerty-5">{`// static variable`}</span>
          {"\n"}
          <span className="qwerty-3">&nbsp; &nbsp;void </span>
          <span className="qwerty-4">abc</span>
          <span className="qwerty-1">() </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span> 
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">y</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">50</span>
    <span className="qwerty-8">,</span>
    <span className="qwerty-4">z;</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;z</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8">*</span>
          <span className="qwerty-4">y;</span>
          {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">z</span>
      <span className="qwerty-1">);</span>
      {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>    
          {"\n"}
          <span className="qwerty-3">&nbsp; &nbsp;void </span>
          <span className="qwerty-4">xyz</span>
          <span className="qwerty-1">() </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span> 
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">f</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">80</span>
    <span className="qwerty-8">,</span>
    <span className="qwerty-4">g;</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;g</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">b</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">f;</span>
          {"\n"}

<span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
    <span className="qwerty-8">.</span>
    <span className="qwerty-2">out</span>
    <span className="qwerty-8">.</span>
    <span className="qwerty-2">println</span>
    <span className="qwerty-1">(</span>
      <span className="qwerty-4">g</span>
    <span className="qwerty-1">);</span>
    {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>    
          {"\n"}
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;code </span>
    <span className="qwerty-4">co</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-8">new </span>
    <span className="qwerty-4">code</span>
    <span className="qwerty-1">();</span>
    {"\n"}
  
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;co</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">abc</span>
        <span className="qwerty-1">();</span>

        {"\n"}
        <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;co</span>
        <span className="qwerty-8">.</span>
        <span className="qwerty-4">xyz</span>
        <span className="qwerty-1">();</span>

        {"\n"}

      
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>






 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1000 </span> 
          {"\n"} 
          <span className="qwerty-10">&nbsp;140 </span> 
          {"\n"} 
            </code>{"   "}
            </pre>
      </div>
    </div>
    
    
  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/java-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jtypevar;